// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__14tIx","gfeWrapper":"CalendarEvent_gfeWrapper__1EFVZ"};